import { useCallback, useEffect, useState } from "react";
import { Select } from "../controls";
import cities from "../utils/cities.json";

const StatesDropdown = ({ name, value, onChange }: any) => {
  const [cats, setCats] = useState<any[]>([]);

  const reload = useCallback(() => {
    let t = cities?.map((k: any) => {
      return { label: k?.name, value: k?.abbreviation };
    });
    setCats(t);
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <Select
      name={name}
      title="Choose..."
      options={cats}
      showFirstOption={true}
      value={value}
      onChange={onChange}
    />
  );
};

export default StatesDropdown;
